export { default } from './ShopTerms';
